import { render, staticRenderFns } from "./begin.vue?vue&type=template&id=66ee7d1f&scoped=true&"
import script from "./begin.vue?vue&type=script&lang=js&"
export * from "./begin.vue?vue&type=script&lang=js&"
import style0 from "./begin.vue?vue&type=style&index=0&id=66ee7d1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee7d1f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutTabs: require('/opt/render/project/src/channels2022/src/components/about/AboutTabs.vue').default})
